import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-4 mx-auto px-2 md:px-4 xl:px-10 flex items-center justify-between w-full bg-white top-0 z-3 shadow-modal bg-opacity-70 sticky" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "grid md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[1200px] w-full mx-auto px-4 py-10 md:px-10 md:py-0" }
const _hoisted_4 = { class: "col-span-full text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl md:text-[36px] lg:text-[50px] text-wrh-gray-darker font-bold" }, "Customer Care", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-18r md:text-2xl lg:text-[40px] mt-6 mb-14 text-wrh-blue-darker" }, [
  /*#__PURE__*/_createTextVNode("NEED MORE HELP?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Choose your location and send a message to your team of dedicated professionals who will help solve your issues!")
], -1)
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "wrh-input-label mb-2"
}, "Name", -1)
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "wrh-input-label mb-2"
}, " Email ", -1)
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "wrh-input-label mb-2"
}, "Phone", -1)
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "location",
  class: "wrh-input-label mb-2"
}, "Choose Your Location", -1)
const _hoisted_15 = { class: "py-2 px-3 hover:bg-wrh-gray-extralight cursor-pointer text-12r text-wrh-gray-dark" }
const _hoisted_16 = { class: "relative col-span-full" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "wrh-input-label mb-2"
}, "Message", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-full text-center md:text-right" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "bg-wrh-blue-light rounded-3xl text-white p-2 w-[270px] w-full text-14r"
  }, " Send Message ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "message px-4 md:px-10 py-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-black font-trebuchet" }, "Disclaimer: Thank you for your request. A warranty Tech will be in contact with you within 24 to 48 hours (Mon – Fri 8am to 5pm). If this is an emergency, consisting of electrical, HVAC – loss of heat/air, plumbing or roof and appliance issues, please call the respective Contractor. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-black font-trebuchet" }, " NOTE: All warranty requests must be submitted through the My Home 24-7 site. ")
], -1)

import { onMounted, ref } from 'vue';
import {
  Listbox, ListboxButton, ListboxOptions, ListboxOption,
} from '@headlessui/vue';
import { checkFormValidations, contactUsFormApiResponse } from './services/service';
import { postContactUsForm, getDivisions } from '@/api';
import { showLoader } from '@/util/funcs';
import Alert from '@/components/Alert.vue';
import Chevron from '@/components/icons/ChevronIcon.vue';
import Logo from '@/components/icons/Logo.vue';
import MyHomeLogo from '@/components/icons/MyHomeLogo.vue';
import { Routes } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initialState = {
  email: '',
  phone: '',
  name: '',
  message: '',
  division: {
    id: '',
    name: 'Choose',
  },
};
const contactUsForm = ref(initialState);
const responseApi = ref({});
const contactUsError = ref({
  email: true,
  phone: true,
  name: true,
  message: true,
  division: true,
});

const modalActive = ref('');
let valid = false;
const divisions = ref<{ id: string; name: string }[] | null>(null);

onMounted(async () => {
  divisions.value = await getDivisions();
});

const check = () => {
  contactUsError.value = checkFormValidations({
    ...contactUsForm.value,
    division: contactUsForm.value.division.name,
  });
  if (Object.values(contactUsError.value).includes(false)) {
    valid = false;
  } else {
    valid = true;
  }
};

const closeAlertBox = () => {
  modalActive.value = '';
};

const showModal = () => {
  const value = contactUsFormApiResponse(responseApi.value);
  modalActive.value = value;
};

const submit = async () => {
  showLoader(true);
  check();
  if (valid) {
    responseApi.value = await postContactUsForm(contactUsForm.value);
    showModal();
  }
  showLoader(false);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: { name: _unref(Routes).LOGIN }
      }, {
        default: _withCtx(() => [
          _createVNode(Logo, { class: "w-[200px] md:max-w-full h-auto" })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("form", {
      action: "#",
      method: "POST",
      class: "",
      onSubmit: _withModifiers(submit, ["prevent"]),
      novalidate: ""
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MyHomeLogo, {
            class: "w-full m-auto py-5 max-w-[200px] md:max-w-[300px] lg:max-w-[500px]",
            alt: "William Ryan Homes 24-7"
          }),
          _hoisted_5,
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (contactUsForm.value.name = $event)),
            class: _normalizeClass(['wrh-input border-transparent bg-wrh-blue-background text-black', contactUsError.value.name ? '' : 'border-red-600'])
          }, null, 2), [
            [_vModelText, contactUsForm.value.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            id: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (contactUsForm.value.email = $event)),
            name: "email",
            type: "email",
            autocomplete: "email",
            class: _normalizeClass(['wrh-input border-transparent bg-wrh-blue-background text-black', contactUsError.value.email ? '' : 'border-red-600'])
          }, null, 2), [
            [_vModelText, contactUsForm.value.email]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "phone",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (contactUsForm.value.phone = $event)),
            class: _normalizeClass(['wrh-input border-transparent bg-wrh-blue-background text-black', contactUsError.value.phone ? '' : 'border-red-600'])
          }, null, 2), [
            [_vModelText, contactUsForm.value.phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_unref(Listbox), {
            modelValue: contactUsForm.value.division,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (contactUsForm.value.division = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ListboxButton), {
                class: _normalizeClass(['border-transparent bg-wrh-blue-background w-full wrh-input text-left relative text-black', contactUsError.value.division ? '' : 'border-red-600'])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(contactUsForm.value.division.name) + " ", 1),
                  _createVNode(Chevron, { class: "w-6 h-6 absolute top-[10px] right-[7px]" })
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_unref(ListboxOptions), { class: "absolute w-full z-10 bg-wrh-blue-background overflow-auto max-h-44" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(divisions.value, (division) => {
                    return (_openBlock(), _createBlock(_unref(ListboxOption), {
                      as: "template",
                      key: division.id,
                      value: division
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("li", _hoisted_15, _toDisplayString(division.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            id: "message",
            class: _normalizeClass(['wrh-input border-transparent bg-wrh-blue-background resize-none h-20 text-16r text-black', contactUsError.value.message ? '' : 'border-red-600']),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (contactUsForm.value.message = $event))
          }, null, 2), [
            [_vModelText, contactUsForm.value.message]
          ])
        ]),
        _hoisted_18
      ])
    ], 40, _hoisted_2),
    _hoisted_19,
    (modalActive.value)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          alertType: modalActive.value,
          onCloseAlert: closeAlertBox
        }, null, 8, ["alertType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})